import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ResponseCatalog, RequestParams } from 'Models'
import { UnBlockRequestModel } from 'Pages/orders'
import { Callback } from 'Types/utilTypes'

type UnBlockRequestState = {
	unBlockRequests: ResponseCatalog<UnBlockRequestModel>
	requestParams: RequestParams
	requestBackToCheck: boolean
	unBlockRequest: UnBlockRequestModel
	formState: {
		open: boolean
		item?: UnBlockRequestModel
	}
}
const initialStateUnBlockRequest: UnBlockRequestState = {
	unBlockRequests: new ResponseCatalog(),
	requestParams: new RequestParams(),
	requestBackToCheck: false,
	unBlockRequest: null,
	formState: {
		open: false,
		item: undefined,
	},
}

export namespace UnBlockRequestNS {
	export type GetAll = PayloadAction<{
		params: RequestParams
		clear?: boolean
		callback?: Callback
	}>
	export type SetAll = PayloadAction<ResponseCatalog<UnBlockRequestModel>>
	export type SetParams = PayloadAction<RequestParams>

	export type Confirm = PayloadAction<{
		id: number
		comment: string
	}>
	export type Decline = PayloadAction<{
		id: number
		comment: string
	}>

	export type Clarify = PayloadAction<{
		id: number
		comment: string
	}>

	export type BackToChecking = PayloadAction<{ id: number; data: any }>

	export type loadBackToChecking = PayloadAction
	export type successBackToChecking = PayloadAction

	export type GetOne = PayloadAction<number>

	export type SetOne = PayloadAction<UnBlockRequestModel>

	export type SetStatusAgreement = PayloadAction<{
		id: string
		idRequest: number
		status: string
	}>
	export type OpenForm = PayloadAction<{ item?: UnBlockRequestModel }>
	export type CloseForm = PayloadAction
}

export const unBlockRequestSlice = createSlice({
	name: 'unBlockRequests',
	initialState: initialStateUnBlockRequest,
	reducers: {
		getAll: (state, action: UnBlockRequestNS.GetAll) => {},
		setAll: (state, action: UnBlockRequestNS.SetAll) => {
			state.unBlockRequests = action.payload
		},
		setParams: (state, action: UnBlockRequestNS.SetParams) => {
			state.requestParams = action.payload
		},
		clearAll: (state) => {
			state.unBlockRequests = new ResponseCatalog<UnBlockRequestModel>()
			state.requestParams = new RequestParams()
		},

		confirm: (state, action: UnBlockRequestNS.Confirm) => {},
		decline: (state, action: UnBlockRequestNS.Decline) => {},
		clarify: (state, action: UnBlockRequestNS.Clarify) => {},
		backToChecking: (state, action: UnBlockRequestNS.BackToChecking) => {},
		loadBackToChecking: (state, action: UnBlockRequestNS.loadBackToChecking) => {
			state.requestBackToCheck = true
		},

		successBackToChecking: (state, action: UnBlockRequestNS.successBackToChecking) => {
			state.requestBackToCheck = false
		},

		getOne: (state, action: UnBlockRequestNS.GetOne) => {},

		setOne: (state, action: UnBlockRequestNS.SetOne) => {
			state.unBlockRequest = action.payload
		},

		setStatusAgreement: (state, action: UnBlockRequestNS.SetStatusAgreement) => {},
		openForm: (state, action: UnBlockRequestNS.OpenForm) => {
			state.formState = {
				open: true,
				item: action.payload.item,
			}
		},
		closeForm: (state, action: UnBlockRequestNS.CloseForm) => {
			state.formState = initialStateUnBlockRequest.formState
		},
	},
})
